import jQuery from 'jquery';
import './almc/home-porto.js';
/*
 * Antibot: publica window.AntibotForm y engancha SOLO los formularios que lo
 * piden por atributo (<form data-antibot-profile=... data-antibot-route=...>).
 * Los de /contact no lo piden: siguen llamando a attach() desde su vista, donde
 * el orden respecto a su propio listener de submit se ve de un vistazo.
 *
 * Viaja aqui —y no solo en la entrada `public-core`— porque las 19 vistas que
 * postean a /contact extienden `layouts.almc`, y ese layout carga este fichero,
 * NO public-core. Sin este import, `window.AntibotForm` no existe en ninguna de
 * ellas: el `if (window.AntibotForm)` de las vistas no entra nunca y todo el
 * cableado queda en un no-op perfecto, verde en los tests y sin un solo token
 * en produccion. Es un modulo autonomo sin dependencias, asi que no duplica
 * nada de lo que ya trae el bundle.
 */
import './antibot/antibot-form.js';

const $ = jQuery;

$(document).ready(function() {
    console.log('form.js cargado, inicializando manejo del formulario');

    $('#contactForm').on('submit', function(e) {
        e.preventDefault();
        const form = $(this);
        const formData = form.serialize();
        const messages = $('#formMessages');

        // Limpiar mensajes anteriores
        messages.empty();
        $('.error-message').empty();
        $('.form-control, .form-check-input').removeClass('is-invalid');

        $.ajax({
            url: window.formSubmitUrl,
            type: 'POST',
            data: formData,
            success: function(response) {
                if (response.success) {
                    messages.html('<div class="alert alert-success">' + response.message + '</div>');
                    form[0].reset();
                }
            },
            error: function(xhr) {
                if (xhr.status === 422) {
                    const errors = xhr.responseJSON.errors;
                    console.log('Errores de validación:', errors); // Depuración

                    $.each(errors, function(field, messages) {
                        const errorElement = $('#' + field + '-error');
                        if (errorElement.length) { // Verificar que el elemento exista
                            errorElement.html(messages.join('<br>'));
                            $('[name="' + field + '"]').addClass('is-invalid');
                        }
                    });

                    messages.html('<div class="alert alert-danger">Por favor, corrige los errores en el formulario.</div>');
                } else {
                    messages.html('<div class="alert alert-danger">Ocurrió un error. Por favor, intenta de nuevo.</div>');
                }
            }
        });
    });




});

